// @flow

const validationHelper = {

  // Email validation
  email: (value: string) => {
    if( !value ) return false;

    return value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) !== null ? true : false;
  },

  // Password validation
  // 1) >= 8 length
  // 2) at least one capital letter
  // 3) at least one number AND/OR special char (it can have both)
  passMinRequirements: (value: string) => {
    var is_ok = false;
    var val   = value;

    // Check if password minimal length is at least 8
    if( val && val.length >= 8 ) {

      // Check if string contain at least on capital letter
      if( /[A-Z]/.test(val) ) {

        // Check if string contains at least one number AND/OR special char
        if( /\d/.test(val) || /(?=.*\W)/.test(val) ) {
          is_ok = true;
        }
      }
    }

    return is_ok;
  },

  // Password strength meter
  passStrengthMeter: function(inputVal: string) {
    return this.isSatisfied(inputVal && inputVal.length >= 8) +
           this.isSatisfied(inputVal && /[A-Z]/.test(inputVal)) +
           this.isSatisfied(inputVal && /[a-z]/.test(inputVal)) +
           this.isSatisfied(inputVal && /(?=.*\W)/.test(inputVal)) +
           this.isSatisfied(inputVal && /\d/.test(inputVal));
  },

  passMatches: (oldPass: string, newPass: string) => oldPass === newPass,

  // Statement helper for criteria match
  isSatisfied: function(criteria: any) {
    return criteria ? 1 : 0;
  }

}

export default validationHelper;



// WEBPACK FOOTER //
// ./src/helpers/validation.helper.js